export default {
  siteName: "La Cité de l'Histoire",
  refererHostWhitelist: [
    'cite-histoire.placeminute.com',
    'amaclio.com',
    'www.eternellenotredame.com',
    'ooeo.fr',
  ],
};
